module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_EN-03-8bdb2aca8b73f09cb7f796b4a1b16313.svg";